import { configureStore } from '@reduxjs/toolkit'
import { createLogger } from 'redux-logger'

import reducers from './reducers'

const logger = createLogger({
  collapsed: true
})

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger)
})

export default store

// Type definitions
export type AppStore = typeof store
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']

export type GetStateFunc = () => RootState
